import { Trans } from "@lingui/react/macro"
import React, { useState } from "react"

import Header from "../../design-system/header"
import Paragraph from "../../design-system/paragraph"
import { classNames } from "../../utils/class-names"
import NewsletterEmailForm from "../layout/footer/newsletter-email-form"
import * as styles from "./index.module.scss"

const variants = {
  footer: {
    title: <Trans>Stay in the loop</Trans>,
    description: <Trans>Subscribe to our newsletter</Trans>,
    backgroundColor: "neutral100",
  },
  blog: {
    title: <Trans>Join our newsletter</Trans>,
    description: (
      <Trans>
        Get incentive insights and industry best practices delivered to your
        inbox monthly.
      </Trans>
    ),
    backgroundColor: "neutral80",
  },
} as const

type Props = {
  variant: keyof typeof variants
}

const NewsletterCta = ({ variant }: Props) => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const { title, description, backgroundColor } = variants[variant]

  return (
    <div className={classNames(styles.container, styles[backgroundColor])}>
      <div className={styles.textContainer}>
        <Header as="h3" variant="3" className={styles.title}>
          {!showConfirmation ? title : <Trans>Thanks for subscribing.</Trans>}
        </Header>
        <Paragraph variant="3" className={styles.description}>
          {!showConfirmation ? (
            description
          ) : (
            <Trans>Keep an eye on your inbox.</Trans>
          )}
        </Paragraph>
      </div>
      <div className={styles.formContainer}>
        {!showConfirmation && (
          <NewsletterEmailForm setShowConfirmation={setShowConfirmation} />
        )}
      </div>
    </div>
  )
}

export default NewsletterCta
